const __WEBPACK_NAMESPACE_OBJECT__ = require("@blueprintjs/icons");